<template>
  <el-drawer custom-class="choseSample-drawer" :title="currentPage==='smsSending'?'添加收信人':'添加样本'" :visible.sync="visible" direction="rtl" :size="974"
    :destroy-on-close="true" append-to-body :before-close="handleClose">
    <div class="w-full h-full pt-4 box-border overflow-hidden">
      <el-tabs class="full-tabs" value="group" type="card">
        <el-tab-pane :label="['telephoneInterviewer','smsSending'].includes(currentPage) ? '从手机群组选择':'从群组选择'" name="group">
          <div class="w-full h-full px-6 pt-6 pb-8 box-border flex flex-col overflow-auto">
            <header class="w-full mb-3 flex items-center justify-between">
              <div class="flex-1">
                <el-select :disabled="condition.typeDisabled" v-model="condition.type" size="small"
                  class="field-text-size field-text-spacing" style="width: 128px" placeholder="群组类型"
                  @change="changeConditionType">
                  <el-option v-for="item of typeList.filter(it=>it.isShow)" :key="item.id" :label="item.label" :value="item.id" />
                </el-select>
                <el-select filterable :disabled="condition.typeDisabled" v-model="condition.group" size="small" class="field-text-size field-text-spacing"
                  style="width: 330px;margin-left: 12px;margin-right: 12px" placeholder="请选择群组" @change="changeConditionGroup">
                  <el-option v-for="item of groups" :key="item.id" :label="item.groupName" :value="item.id" />
                </el-select>
                <!-- <span class="ml-3 text-theme text-medium cursor-pointer select-none"
                  @click="scVisible = true">筛选条件</span> -->
                  <DialogConditionBtn :disabled="conditionBtnDisabled" :filter="conditions" :btnText="'筛选条件'" :btnPlain="true" @save="onSaveFilter"></DialogConditionBtn>
              </div>
              <div class="flex items-center">
                <el-button size="small" class="ml-3 text-medium" @click="toSampleGroup">群组管理</el-button>
              </div>
            </header>
            <div class="flex-1" v-if="(list.length > 0 || columns.length > 0) || conditions.rules.length > 0">
              <data-table ref="tableRef" class="w-full h-full overflow-hidden"
                cell-class-name="truncate-table-cell-wrap" align="left" :data="list"
                :loading="tableLoading" :columns="columns" :show-page="list.length > 0" :page="page"
                :disabled-all-check="checkAll" selection @selection-change="changeSelected" @size-change="changeSize"
                @pagination-current-change="changeNum">
                <template #local="{ row }">
                  <div v-truncate="joinStr(row.local)"></div>
                </template>
                <template #empty>
                  <slot name="empty" v-if="$slots['empty']"></slot>
                  <el-empty v-else></el-empty
                  ><!-- 默认：图片+暂无数据 -->
                </template>
                <template #page-left>
                  <div class="flex items-center">
                    <p class="mr-6 text-medium text-theme-black-650">
                      <el-checkbox :disabled="list.length === 0 || checkAll" v-model="checkAll">
                        已选择 <span class="text-theme">{{ checkAll ? page.total : selectList.length }}</span> 项
                      </el-checkbox>
                    </p>
                    <el-checkbox v-model="checkAll" :disabled="page.total === 0">选择全部</el-checkbox>
                    <el-button :disabled="disabledAdd" type="primary" size="small" class="ml-3" @click="addHandle">
                      {{currentPage === 'smsSending' ? '添加收信人' : '添加样本'}}
                    </el-button>
                  </div>
                </template>
              </data-table>
            </div>
            <footer class="mt-5 mb-8 px-4 py-3 box-border bg-card-bg-gray">
              <header class="leading-6 text-medium text-theme-black-850">说明：</header>
              <ul class="flex flex-col text-medium text-theme-black-850">
                <li class="leading-6">1. 无手机号的样本将在保存时被自动剔除</li>
                <li class="leading-6">2. 相同手机号重复添加时，仅保留一个收件人</li>
              </ul>
            </footer>
            <!-- <search-condition ref="searchCondition" :visible.sync="scVisible" @search="searchCondition" /> -->
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-drawer>
</template>
<script>
import DataTable from '@/components/base/DataTable'
import SearchCondition from '@/components/base/SearchCondition'
import DialogConditionBtn from '@/views/home/more-app/investigator-lib/DialogConditionBtn.vue'
import { getSampleGroupInfoByGroupType, getSampleHeader, getSampleAnsPage, wjsampleShowFields, saveSampleAnsIdsForSms } from '@/api/wenjuan/offline'
import GlobalConfig from '@/global/config'
export default {
  name: 'InitSample',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number || String,
      default: 0
    },
    group: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: String,
      default: ''
    },
    tableDataIds:{
      type: Array,
      default: []
    }
  },
  provide(){  
    return {  
      params:{
        showStatFields: false,
        investigatorFilter: true,
        getGroupId : () => this.condition.group
      } 
    }  
  },
  components: {
    DataTable,
    SearchCondition,
    DialogConditionBtn
  },
  watch: {
    type(val) {
      if (val) {
        // this.condition.type = val;
        this.condition.typeDisabled = true;
        // this.condition.group = this.group;
        // this.changeConditionGroup(this.group);
      } else {
        // this.condition.type = '';
        // this.condition.group = '';
        this.condition.typeDisabled = false;
      }
    },
    visible(val){
      if(val){
        this.getInitData();
      }
    }
  },
  data() {
    return {
      scVisible: false, // 筛选弹窗
      tableLoading: false,
      checkAllSource: false,
      conditionBtnDisabled: true,// 高级筛选按钮是否禁用
      condition: {
        typeDisabled: false,
        groupDisabled: false,
        type: 1,
        group: '',
        groupName: ''
      },
      typeList: [
        { id: 1, label: '手机群组',isShow:true },
        { id: 2, label: '邮箱群组',isShow: ['telephoneInterviewer','smsSending'].includes(this.currentPage) ? false : true },
        { id: 3, label: '点位群组',isShow: ['telephoneInterviewer','smsSending'].includes(this.currentPage) ? false : true },
      ],
      groups: [
        // { id: '1', groupName: '样本一' },
        // { id: '2', groupName: '样本二' },
        // { id: '3', groupName: '样本三' },
      ],
      list: [
        // { id: "1", name: '张三1', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "2", name: '张三2', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "3", name: '张三3', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "4", name: '张三4', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "5", name: '张三5', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "6", name: '张三6', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "7", name: '张三7', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
      ],
      selectList: [],
      page: {
        current: 1,
        pageSizes: [10, 20, 30, 40, 50],
        size: 10,
        total: 1
      },
      conditions: {
        conditionRule: 2,
        ruleGroups:[],
        rules: []
      },
      columns: [
        { fixed: 'left', label: '姓名', value: 'name', width: 80 },
        { fixed: 'left', label: '手机号', value: 'phone', width: 150 },
        { fixed: false, label: '邮箱', value: 'email', width: 150 },
        { fixed: false, label: '性别', value: 'sex', width: 150 },
        { fixed: false, label: '出生日期', value: 'birthday', width: 150 },
        { fixed: false, label: '年龄区间', value: 'ages', width: 150 },
        { fixed: false, label: '居住地', value: 'address', width: 150 },
      ]
    }
  },
  computed: {
    disabledAdd() {
      if (this.list.length === 0) return true
      return !this.checkAll && this.selectList.length === 0
    },
    checkPageAll: {
      get() {
        if (this.list.length === 0) return false
        const sIds = this.selectList.map(m => m.id)
        return this.list.every(e => sIds.includes(e.id))
      },
      set() {
        const table = this.$refs.tableRef
        if (table) {
          table.toggleAllSelection()
        }
      }
    },
    checkAll: {
      get() {
        if (this.page.total === 0) return false
        return this.selectList.length === this.page.total ? true : this.checkAllSource
      },
      set(bool) {
        if (!bool) {
          this.selectList.splice(0)
          this.$refs.tableRef.clearSelection()
        }
        this.checkAllSource = bool
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleClose', false);
    },
    // 群组管理 链接跳转
    toSampleGroup() {
      this.$router.push({name:'sample-company'})
    },
    // 清除表格中的所有选中状态
    clearSelection() {
      this.$refs.tableRef.clearSelection();
      this.checkAll = false;
    },
    // 选择群组类型下拉框
    changeConditionType(val) {
      this.condition.group = "";
      getSampleGroupInfoByGroupType({
        groupType: val
      }).then(res => {
        if (res.data.code === 0) {
          this.groups = res.data.data;
        }
      })
      this.list = [];
      // 重置高级筛选选项
      this.conditions = {
        conditionRule: 2,
        ruleGroups:[],
        rules: []
      };
      this.list.length > 0 && this.clearSelection();
    },
    // 选择群组
    changeConditionGroup(val) {
      if (val) {
        // 获取动态列和表格数据
        this.getColumns(val).then(()=> {
          this.getTableData(val);
          this.condition.groupName = this.groups.find(it=> it.id === val).groupName || ''; 
          this.conditionBtnDisabled = false;
        })
        this.list.length > 0 && this.clearSelection();
        // this.$refs.tableRef.doLayout();
        console.log('this.$refs.tableRef',this.$refs.tableRef)
      }
    },
    getTableData(groupId) {
      this.tableLoading = true
      let surveyId = '';
      if(this.currentPage === 'smsSending'){
         surveyId = GlobalConfig.getSurveyId();
      }else{
        surveyId = '';
      }
      getSampleAnsPage({
        current: this.page.current,
        size: this.page.size,
        tableDataIds:this.tableDataIds,
        groupId,
        ...this.conditions,
        surveyId
      }).then(res => {
        if (res.data.code === 0) {
          this.page.total = res.data.data.total;
          this.list = res.data.data.records;
          this.list.length > 0 && this.clearSelection();
        } else {
          this.$message.error(res.data.msg)
        }
      }).finally(()=> {
        this.tableLoading = false
      })
    },
    getColumns(groupId) {
      return getSampleHeader({
        groupId
      }).then(res => {
        if (res.data.code === 0) {
          this.columns = res.data.data.map(
            (item,idx)=> (
              { 
                label: item.name,
                value: String(item.index),
                fixed: idx <= 1 ?'left' : false,
                width: 150
              }
            ));
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 选中筛选弹窗回调
    // 高级筛选回调
    onSaveFilter(params) {
      console.log('onSaveFilter-params',params)
      if(params){
        this.conditions = {...params, conditionRule: 2};
        this.getTableData(this.condition.group)
      }else{
        this.conditions = {
          conditionRule: 2,
          ruleGroups:[],
          rules: []
        };
        this.getTableData(this.condition.group)
      }
    },
    changeSize(size) {
      this.page.size = size;
      this.page.current = 1;
      this.getTableData(this.condition.group)
    },
    changeNum(current) {
      this.page.current = current;
      this.getTableData(this.condition.group)
    },
    changeSelected(list) {
      this.selectList = list;
    },
    smsAddSampleData(){
      let conditions = null;
      if(this.checkAll){
        conditions = this.conditions;
      }else{
        conditions = null;
      }

      saveSampleAnsIdsForSms({
        sampleAnsIds: this.selectList.map(it=> (it.id)),
        surveyId: GlobalConfig.getSurveyId(),
        conditions,
        groupId:this.condition.group
      }).then(res=> {
        if(res.data.code === 0){
          this.$emit('handleSelectList', this.selectList, this.checkAll, this.condition.type, this.condition.group, this.columns, this.condition.groupName)
        }
      })
    },
    addHandle() {
      if (this.condition.type && this.condition.group) {
        // 当前为短信发送的添加样本
        if(this.currentPage === 'smsSending'){
          console.log('调用短信发送样本添加接口');
          this.smsAddSampleData();
          // this.$emit('handleSelectList', this.selectList, this.checkAll, this.condition.type, this.condition.group, this.columns, this.condition.groupName)
        }else{
          this.$emit('handleSelectList', this.selectList, this.checkAll, this.condition.type, this.condition.group, this.columns, this.condition.groupName, this.conditions)
          this.selectList = [];
          this.clearSelection();
          this.list = [];
        }
      } else {
        this.$message.warning('请选择群组或样本');
      }

    },
    // 获取初始化数据
    getInitData(){
      if(this.type !== 0 ){
        getSampleGroupInfoByGroupType({
          groupType: this.type
        }).then(res => {
          if (res.data.code === 0) {
            this.groups = res.data.data;
          }
        }).then(()=> {
          this.condition.type = this.type;
          this.condition.group = this.group;
          this.conditionBtnDisabled = false;
          // this.changeConditionType(this.group);
          this.changeConditionGroup(this.group)
        })
      }else{
        this.condition.type = 1;
        this.condition.group = '';
        this.conditionBtnDisabled = false;
        this.columns = [];
        this.list = [];
        this.changeConditionType(1);
      }
    }
  },
  created(){
    // this.getInitData();
  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .choseSample-drawer {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-table .el-table__fixed {
        height:auto !important; 
        bottom: 8px !important;
      &::before {
        background-color: transparent;
      }
    }
  }
}
</style>